import styles from './Sample.module.scss';

import type { FC } from 'react';

// TODO このファイルは仮で追加した物です、不要になったら削除する

export const Sample: FC = () => (
  <button className={`${styles.button}`}>Sample</button>
);
